import { render, staticRenderFns } from "./AssessmentApply.vue?vue&type=template&id=f2d025ce&scoped=true&lang=pug&"
import script from "./AssessmentApply.vue?vue&type=script&lang=js&"
export * from "./AssessmentApply.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentApply.vue?vue&type=style&index=0&id=f2d025ce&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d025ce",
  null
  
)

export default component.exports